import { render } from "./partnerCreate.vue?vue&type=template&id=fb3543a2&scoped=true"
import script from "./partnerCreate.vue?vue&type=script&lang=js"
export * from "./partnerCreate.vue?vue&type=script&lang=js"

import "./partnerCreate.vue?vue&type=style&index=0&id=fb3543a2&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb3543a2"]])

export default __exports__